module.exports = __webpack_public_path__ + "static/img/banner.ca1fdd4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner.jpg
// module id = 189
// module chunks = 12